import React from 'react';
import { Spinner } from '@heroui/react';

const SpinnerLoader: React.FC<{
  fullscreen?: boolean;
}> = ({ fullscreen = true }) => {
  return (
    <div className={`flex items-center justify-center ${fullscreen ? 'min-h-screen' : ''}`}>
      <Spinner size="lg" color="primary" />
    </div>
  );
};

export default SpinnerLoader;
